import Chip from "@mui/material/Chip";
import "./chip-group.scss";

export interface ChipGroupProps {
  label: string;
  options: string[];
  selected: string[];
  onChange: (val: string[]) => void;
}

export default function ChipGroup({
  label,
  options,
  selected,
  onChange,
}: ChipGroupProps) {
  const toggle = (opt: string) =>
    onChange(
      selected.includes(opt)
        ? selected.filter((s) => s !== opt)
        : [...selected, opt]
    );

  return (
    <div className="chip-group">
      <span className="chip-group__label">{label}</span>
      <div className="chip-group__chips">
        {options.map((opt) => (
          <Chip
            key={opt}
            label={opt}
            onClick={() => toggle(opt)}
            variant={selected.includes(opt) ? "filled" : "outlined"}
            color={selected.includes(opt) ? "primary" : "default"}
          />
        ))}
      </div>
    </div>
  );
}
